import { render, staticRenderFns } from "./personalityItem.vue?vue&type=template&id=4d189b85&scoped=true&"
import script from "./personalityItem.vue?vue&type=script&lang=js&"
export * from "./personalityItem.vue?vue&type=script&lang=js&"
import style0 from "./personalityItem.vue?vue&type=style&index=0&id=4d189b85&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d189b85",
  null
  
)

export default component.exports